<template>
  <div v-if="active">  
    <div class="md-layout">
      <div class="md-layout-item md-size-100 mx-auto text-center">
        <h2 class="title">Escolha o plano ideal para você</h2>
        <!--h5 class="description mobile-hidden" v-if="order.coupon == 'TRIAL' && order.couponType == 'Free Setup'">
          Comece sua loja virtual gratuitamente!
        </h5-->
        <h5 class="description mobile-hidden" v-if="order.coupon == 'TRIAL' && order.couponType == 'Free Setup'">
          Sua loja será ativada gratuitamente. Escolha qual plano pretende utilizar após o período de testes.
        </h5>
        
        <div v-if="session.cycle != 'annually'" slot="description" class="md-group text-center">
          <md-button class="md-round" :class="{'md-primary': order.cycle != 'annually'}" @click="changeCycle('monthly')">Mensal</md-button>
          <md-button class="md-round" :class="{'md-primary': order.cycle == 'annually'}" @click="changeCycle('annually')">Anual com desconto</md-button>
        </div>
      </div>
    </div>

    <div class="md-layout text-center">
      <div class="md-layout-item md-medium-size-25 md-small-size-50 md-xsmall-size-100 md-size-25" v-for="(plan, index) in plans" :key="plan.name">
        
        <pricing-card class="plans-card" :card-class="getCardClass(index)">          
          <span class="border" slot="category"></span>
          <span class="border" slot="category"></span>
          <span class="border" slot="category"></span>
          <span class="border" slot="category"></span>
          <h6 slot="category" class="category">{{plan.name}}</h6>

          <md-icon class="plan-icon" :class="'icon-'+getCardColor(index)" slot="icon">{{plan.icon}}</md-icon>
          <md-icon class="plan-icon" :class="'icon-'+getCardColor(index)" slot="category">{{plan.icon}}</md-icon>

          <!-- FREE TRIAL -->
          <span slot="title" v-if="totalFreeDays(index) > 0">
            <h6 class="title">{{totalFreeDays(index)}} dias grátis</h6>
            <h4 class="title">
              <small>
                <span class="title" v-if="originalCyclePrice(index) > currentCyclePrice(index)"><s><small>de R${{$functions.currencyFormat(originalCyclePrice(index))}}</small></s><br/></span>
                <span v-if="originalCyclePrice(index) > currentCyclePrice(index)">por </span>
                <span v-else-if="totalFreeDays(index) > 0">depois </span>R$
              </small>
              <b>{{$functions.currencyFormat(currentCyclePrice(index))}}</b>
            </h4>       
          </span>

          <!-- DISCOUNT -->
          <h4 class="title" slot="title" v-else-if="(overrideCyclePrice(index) > 0) && (originalCyclePrice(index) > overrideCyclePrice(index))">
            <span class="title"><small><s>de R${{$functions.currencyFormat(originalCyclePrice(index))}}</s></small><br/></span>
            <span class="title"><small>por R$</small><b>{{$functions.currencyFormat(overrideCyclePrice(index))}}</b></span>
          </h4>

          <!-- NORMAL -->
          <h4 class="title" slot="title" v-else>            
            <span class="title" v-if="originalCyclePrice(index) > currentCyclePrice(index)">
              <small><s>de R${{$functions.currencyFormat(originalCyclePrice(index))}}</s></small><br/>
            </span>
            <span class="title">
              <small><span v-if="originalCyclePrice(index) > currentCyclePrice(index)">por </span>R$</small>
              <b>{{$functions.currencyFormat(currentCyclePrice(index))}}</b></span>
          </h4>

          <div slot="title" class="popular" v-if="plan.focus">POPULAR</div>
          <p slot="description" v-html="plan.description" class="card-description"></p>
          <md-button @click="selectPlan(index)" slot="footer" class="md-round" :class="'md-'+getCardColor(index)">Criar Loja</md-button>
        </pricing-card>        
      </div>
    </div>

    <div class="md-layout">
      <div class="md-layout-item md-size-100 mx-auto text-center">
        <p class="footer-info">Todos os nossos planos incluem integração nativa com marketplaces, certificado de segurança SSL, produtos, clientes, usuários e pedidos ilimitados e suporte técnico total.</p>
      </div>
    </div>

  </div>
</template>
<script>

import { PricingCard } from "@/components";

export default {
  data() {
    return {
      session: this.$store.state.session,
      order: this.$store.state.order,

      freeDays: 0,
      plans: [],
    };
  },
  components: {
    PricingCard
  },
  props: {
    active: {
      type: Boolean,
      default: false
    }
  },

  mounted: function () {
    this.$nextTick(function () {
      this.$gtm.trackEvent({
        event: 'Lista de Planos',
        category: "initiatecheckout",
        action: "view",
        transaction_id: this.$store.state.session.id,
        noninteraction: false,
      });

      const params = {'email' : this.$store.state.client.email,
                      'name'  : this.$store.state.client.firstName + " " + this.$store.state.client.lastName, 
                      'phone' : this.$store.state.client.phone };      
      this.$functions.post('initiateOrder', params, 'automation.php');      

      this.loadPlans();
    })
  },

  methods:{
    getCardClass(index) { return (this.plans[index].focus ? "" : "md-card-plain"); },
    getCardColor(index) { return (this.plans[index].focus ? "primary" : "black"); },

    totalFreeDays(index){
      if (!this.couponValid(index)) return 0;

      const freeSetup = this.order.coupon == 'TRIAL' && this.order.couponType == 'Free Setup';
      const planFreeDays = !freeSetup ? 0 : this.plans[index].freeDays > 0 ? parseInt(this.plans[index].freeDays) : 0;
      const affFreeDays = this.order.affid > 0 ? this.$store.state.affiliateFreeDays : 0;      
      const couponFreeDays = this.order.couponFreeDays > 0 ? parseInt(this.order.couponFreeDays) : 0;

      return planFreeDays + affFreeDays + couponFreeDays;
    },

    changeCycle(newCycle) { 
      this.$store.commit('order', ['cycle', newCycle]);
    },

    originalCyclePrice(index){
      if (this.order.cycle == 'annually')
        return this.plans[index].monthly * 12;
      else return parseFloat(this.plans[index].monthly);
    },

    currentCyclePrice(index){
      if (this.order.cycle == 'annually')
        return this.plans[index].annually;
      else return parseFloat(this.plans[index].monthly);
    },

    overrideCyclePrice(index){
      if (!this.couponValid(index)) return 0;
      
      if (this.order.couponType == 'Percentage'){
        const percentage = 1 - (1 / 100) * this.order.couponValue;          
        return parseFloat((this.currentCyclePrice(index)) * percentage);
      }
      else if (this.order.couponType == 'Fixed Amount'){          
        return parseFloat((this.currentCyclePrice(index)) - this.order.couponValue);
      }
      else if (this.order.couponType == 'Price Override'){          
        return parseFloat(this.order.couponValue);
      }
    },

    couponValid(index){
      const cycleValid = this.order.couponCycles.includes(this.order.cycle);
      const packageValid = this.order.couponPackages.includes(this.plans[index].id);

      return cycleValid && packageValid;      
    },

    loadPlans(){
      this.$debug('Plan => loadPlans');
      this.$store.commit('loader', [true, "Aguarde", "Carregando planos..."]);

      const params = {'gid': this.session.gid, 'pid': this.session.pid};

      this.$functions.get('getPlans', params, 'plan.php').then((response) => {        
        this.plans = response.plans;
        //console.log(this.plans);
        this.$store.commit('loader', [false]);

        if (this.plans && this.plans.length == 1) 
          this.selectPlan(0);
        else if (this.session.pid > 0) {
          //Look for spacific Package ID
          for (let i = 0; i < this.plans.length; i++){
            if (this.plans[i].id == this.session.pid)
              this.selectPlan(i);
          }
        }
      });
    },

    selectPlan(index) {
      this.$debug("Selected Plan: " + index);
      this.$emit("on-selected", this.plans[index], this.plans.length);
    }
  },
}
</script>

<style lang="scss" scoped>
@import "../../assets/scss/activation.scss";

.popular{
  background-color: #009900;
  color: #fff;
  width: 5rem;
  height: 1.5rem;
  position: absolute;
  top: 0rem;
  right: 0rem;  
  display: flex;
  justify-content: center;
  align-items: center;
  font-size: 0.7rem;
  font-weight: 500;
  border-top-left-radius: 10px;
  border-bottom-left-radius: 10px;
}
.title{
  color:#333 !important;
  margin-bottom: 15px !important;
}
.card-description{
  font-size: 1rem;  
  line-height: 24px !important;
}
.md-card-plain{
  background-color: transparent;

  -webkit-transition: background-color .5s ease;
  -moz-transition: background-color .5s ease;
  -o-transition: background-color .5s ease;
  transition: background-color .5s ease !important;
}
.md-card-plain:hover{
  box-shadow: 0 1px 4px 0 rgba(0, 0, 0, 0.14) !important;  
  background-color: white !important;  
}

.md-card-pricing .plan-icon{
  display:none;
}
.md-card-icon .plan-icon{
  display: flex !important;
}
.md-icon{
  border-color: #333 !important;
}
h6{
  font-size: 1.4rem;
  margin-bottom: 0px !important;
}
h2,h6,p{
  color:#333 !important;
}
.footer-info{
  color: #555 !important;
}
.md-button:hover{
  background-color: $green !important;
}
.md-button.md-primary:hover{
  background-color: $green !important;
}


//BORDER ANIMATIONS
.md-card.md-card-pricing{
  overflow: hidden;  
}
.md-card.md-card-pricing span.border{
  transition: 0.5;
  opacity: 0;
}
.md-card.md-card-pricing:hover span.border{
  opacity: 1;
}

.md-card.md-card-pricing span.border:nth-child(1){
  position: absolute;
  top: 0;
  left: 0;
  width: 100%;
  height: 3px;
  background: linear-gradient(to right, transparent, #1779ff);
  animation: animate1 2s linear infinite;  
}

@keyframes animate1 {
  0% { transform: translateX(-100%); }
  100% { transform: translateX(100%); }
}

.md-card.md-card-pricing span.border:nth-child(2){
  position: absolute;
  top: 0;
  right: 0;
  width: 3px;
  height: 100%;
  background: linear-gradient(to bottom, transparent, #1779ff);
  animation: animate2 2s linear infinite;
  animation-delay: 1s;
}

@keyframes animate2 {
  0% { transform: translateY(-100%); }
  100% { transform: translateY(100%); }
}

.md-card.md-card-pricing span.border:nth-child(3){
  position: absolute;
  bottom: 0;
  left: 0;
  width: 100%;
  height: 3px;
  background: linear-gradient(to left, transparent, #1779ff);
  animation: animate3 2s linear infinite;
  animation-delay: 2s;
}

@keyframes animate3 {
  0% { transform: translateX(100%); }
  100% { transform: translateX(-100%); }
}

.md-card.md-card-pricing span.border:nth-child(4){
  position: absolute;
  top: 0;
  left: 0;
  width: 3px;
  height: 100%;
  background: linear-gradient(to top, transparent, #1779ff);
  animation: animate4 2s linear infinite;
  animation-delay: 3s;
}

.md-card-pricing .plan-icon.icon-primary{
  color: $blue !important;
}

.md-card-pricing s{
  color: #aaa !important;
}

@keyframes animate4 {
  0% { transform: translateY(100%); }
  100% { transform: translateY(-100%); }
}

@media only screen and (max-width: 600px) {
  .md-card-pricing .plan-icon{
    margin-top: 30px;
    margin-bottom: 0px;
    font-size: 56px !important;
    color: #333 !important;
    display:flex;
  }

  .md-card-pricing .md-card-content .md-card-icon .plan-icon{
    display: none !important;
  }
}

</style>